<template>
  <div class="">
    <Navigate class="d-flex" v-if="navigations.length > 1">
      <template v-for="(item, item_index) in navigations">
        <NavigateItem
          v-if="item_index == 0 || item_index >= (navigations.length - maxShow)"
          :key="`item_index${item_index}`"
          class="fs-sa-14"
          @click="item_index !== (navigations.length - 1) && item.value ? onClick(item.value) : false"
        >
          {{ item_index != 0 && item_index == (navigations.length - maxShow) ? '...' : item.label }} 
          <span v-if="item_index !== (navigations.length - 1)">
            <i class="far fa-chevron-right"></i>
          </span>
        </NavigateItem>
      </template>
    </Navigate>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize } from "@helpers/text.helper";
import { Navigate, NavigateItem } from "./Navigate.styled";
export default {
  components: {
    Navigate,
    NavigateItem,
  },
  data() {
    return {
      maxShow: 3,
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      elActiveParentID: "design/component/elActiveParentID",
      elActiveID: "design/component/elActiveID",
      siteComponents: "design/metadata/siteComponents",
      pageName: "design/metadata/sitePageName",
      components: "design/metadata/components",
    }),
    routes() {
      return this.elActiveID;
    },
    parents() {
      return this.elActiveParentID;
    },

    navigations() {
      const routes = this.routes; 
      const route0 = routes[0]; // component, header, footer, design, website_theme

      if (route0 == 'component') {
        const cmpType = this.$helper.component.findComponentType(this.components, routes[1]);
        if (cmpType.startsWith('SECTION_PAGE_')) // /component/SECTION_PAGE
          return this.genNavComponentSectionPage(); 
        else if (cmpType === 'SECTION') // /component/sec0001
          return this.genNavComponentSection(); 
        else if (cmpType === 'SECTION_CELL') // /component/cll0001
          return this.genNavComponentCell(); 
        else if (cmpType.startsWith('SECTION_WIDGET_')) // /component/wdg0001
          return this.genNavComponentWidget(); 
        else if (cmpType === 'SLIDE_SECTION')  // /component/sec001/slp001
          return this.genNavComponentSlide();
      }
      if (route0 == 'website_theme') {
        return this.genNavWebsiteTheme()
      }

      return this.genNavs(); // from routes
    },
  },
  methods: {
    capitalize,
    genNavs() {
      return this.routes.filter((route) => route != "component").map((item, index) => ({ 
        label: this.capitalize(item), 
        value: {
          lv: index, 
          id: item, 
        } 
      }));
    },
    genNavWebsiteTheme() {
      let nav = []
      this.routes.forEach((item, index) => {
        if (item == 'website_theme') {
          nav.push({
            label: this.capitalize(item), 
            value: null
          })
        } else {
          nav.push({
            label: this.capitalize(item), 
            value: {
              lv: index, 
              id: item, 
            } 
          })
        }
      });
      return nav
    },
    // Component
    genNavComponentNotFound() {
      return [{  label: '???', value: null }];
    },
    genNavTasks(tasks, parentRoutes) {
      if (!tasks || !tasks.length) return [];
      if (tasks.length == 1) 
      return tasks.map((page) => ({ 
        label: this.$t(`engine.sidebarNavigation.${page}`, this.languageEngine),
        value: { lv: 0, id: [...parentRoutes, page] },
      }));
    },
    genNavComponentSectionPage() {
      const cmpID = this.routes[1];
      const cmp = this.$helper.component.findComponent(this.components, cmpID);
      if (!cmp) return this.genNavComponentNotFound();
      const cmpRoutes = ["component", cmp.id];
      const cmpPages = this.routes.slice(2);
      return [
        { 
          label: this.$t(`engine.sidebarNavigation.component.${cmp.type}`, this.languageEngine),
          value: { lv: 0, id: cmpRoutes },
        },
        ...this.genNavTasks(cmpPages, cmpRoutes),
      ];
    },
    genNavComponentSection() {
      const cmpID = this.routes[1];
      const cmp = this.$helper.component.findComponent(this.components, cmpID);
      if (!cmp) return this.genNavComponentNotFound();
      const cmpRoutes = ["component", cmp.id];
      const cmpPages = this.routes.slice(2);
      return [
        { 
          label: this.capitalize(cmp.properties.name),
          value: { lv: 0, id: cmpRoutes },
        },
        ...this.genNavTasks(cmpPages, cmpRoutes),
      ];
    },
    genNavComponentCell() {
      // const sectionID = this.parents[0];
      // const section = this.$helper.component.findComponent(this.components, sectionID);
      // const sectionRoutes = ["component", section.id];
      const cmpID = this.routes[1];
      const cmp = this.$helper.component.findComponent(this.components, cmpID);
      if (!cmp) return [{  label: '???', value: null }];
      const cmpRoutes = ["component", cmp.id];
      const cmpPages = this.routes.slice(2);
      return [
        // { 
        //   label: this.capitalize(section.properties.name),
        //   value: { lv: 0, id: sectionRoutes },
        // },
        { 
          label: this.$t(`engine.sidebarNavigation.component.${cmp.type}`, this.languageEngine),
          value: { lv: 0, id: cmpRoutes },
        },
        ...this.genNavTasks(cmpPages, cmpRoutes),
      ];
    },
    genNavComponentWidget() {
      // const sectionID = this.parents[0];
      // const section = this.$helper.component.findComponent(this.components, sectionID);
      // const sectionRoutes = ["component", section.id];
      // const cmpID = this.routes[1];
      // const cmp = this.$helper.component.findComponent(this.components, cmpID);
      // if (!cmp) return [{  label: '???', value: null }];
      // const cmpRoutes = ["component", cmp.id];
      // const cmpPages = this.routes.slice(2);
      return [
        // { 
        //   label: this.capitalize(section.properties.name),
        //   value: { lv: 0, id: sectionRoutes },
        // },
        // { 
        //   label: this.$t(`engine.sidebarNavigation.component.${cmp.type}`, this.languageEngine),
        //   value: { lv: 0, id: cmpRoutes },
        // },
        // ...this.genNavTasks(cmpPages, cmpRoutes),
      ];
    },
    genNavComponentSlideBlock() {
      const sectionID = (this.parents[0] == 'component') ? this.parents[2] : this.parents[0];
      const section = this.$helper.component.findComponent(this.components, sectionID);
      const sectionRoutes = ["component", section.id];
      const widgetID = this.routes[1];
      const widget = this.$helper.component.findComponent(this.components, widgetID);
      const widgetRoutes = ["component", widget.id];
      const cmpID = this.routes[2];
      const cmp = this.$helper.component.findComponent(this.components, cmpID);
      if (!cmp) return [{  label: '???', value: null }];
      const cmpRoutes = ["component", widgetID, cmp.id];
      return [
        { 
          label: this.capitalize(section.properties.name),
          value: { lv: 0, id: sectionRoutes },
        },
        { 
          label: this.$t(`engine.sidebarNavigation.component.${widget.type}`, this.languageEngine),
          value: { lv: 0, id: widgetRoutes },
        },
        { 
          label: this.$t(`engine.sidebarNavigation.component.${cmp.type}`, this.languageEngine),
          value: { lv: 0, id: cmpRoutes },
        },
      ];
    },
    genNavComponentSlide() {
      const sectionID = (this.parents[0] == 'component') ? this.parents[1] : this.parents[0];
      const section = this.$helper.component.findComponent(this.components, sectionID);
      const sectionRoutes = ["component", section.id];
      return sectionRoutes.filter((route) => route != "component").map((item, index) => ({ 
        label: this.capitalize(item), 
        value: {
          lv: index, 
          id: item, 
        } 
      }));
    },

    onClick(value) {
      this.$store.dispatch("design/component/elActive", {
        lv: value.lv,
        elementID: value.id,
      });
    },
  },
};
</script>

<style>
</style>